import { EmploymentDetails, MailingAddressPayload, User } from '../user';

export type UpdateInfoRequestPayload = Omit<
  User,
  'id' | 'documents' | 'gender' | 'maritalStatus'
> & {
  gender: string;
  maritalStatus: string | null;
  idDocNumber: string;
  idDocType: string;
  idExpiryDate: string;
  countryCode: string;
  taxResidences?: string;
  issueCity: string | null;
  issueCountry: string | null;
  cityOfBirth: string | null;
  mailingAddress?: MailingAddressPayload | null;
};
export type UpdateInfoResponsePayload = User;

export type UpdateInfoReviewRequestPayload = {
  reviewed: boolean;
};

export type UpdateInfoAccuracyRequest = {
  infoAccuracyConfirmed: boolean;
  operationId?: string;
};

export enum ConsentType {
  TaxResidency = 'TAX_RESIDENCY',
  PrivacyPolicy = 'PRIVACY_POLICY',
  ElectronicBanking = 'ELECTRONIC_BANKING',
  BiometricConsent = 'BIOMETRIC_CONSENT',
  TermsOfUse = 'TERMS_OF_USE',
}

export type ConsentDocument = {
  consentType: ConsentType;
  currentVersion: string;
  url: string;
  acceptedVersion: string | null;
};

export type UpdateDocumentAgreementRequestPayload = {
  documents: Array<{
    consentType: ConsentType;
    agreed: boolean;
    version: string;
  }>;
};

export type UpdateDocumentAgreementResponsePayload = {
  message: string;
};

export type UpdatePhoneNumberRequestPayload = {
  phoneNumber: string;
  countryCode: string;
};
export type UpdatePhoneNumberResponsePayload = {
  message: string;
};

export type UpdateBiometricConsentResponsePayload = {
  message: string;
};

export type UpdateEmploymentInfoPayload = {
  currentUser: User;
  employmentDetailed: EmploymentDetails & Pick<User, 'riskSectorFlag'>;
};

export type UpdateEXCPersonalInfoPayload = {
  employmentDetailed: UpdateEmploymentInfoPayload;
  infoRequest: UpdateInfoRequestPayload;
};

export type AccountDepositInfo = {
  accountTypeId: string;
  accountNo?: string;
  estimatedMonthlyDepositAmount?: number;
  estimatedMonthlyDepositCount?: number;
  estimatedMonthlyCashDepositAmount?: number;
  willSendReceiveFromOthers?: boolean;
  willUseInternationalWireTransfers?: boolean;
  isBusinessPurpose?: boolean;
  fundingSource?: string;
  operationId?: string;
};

export type UpdateDepositInfoRequestPayload = Array<AccountDepositInfo>;

export type RemediationDepositInfo = Omit<AccountDepositInfo, 'accountNo'> & {
  accountNo: string;
};
export type UpdateRemediationDepositInfoRequestPayload =
  Array<RemediationDepositInfo>;

export type UpdateRemediationDepositInfoRequest = {
  operationId?: string;
  payload: UpdateRemediationDepositInfoRequestPayload;
};

export type UpdateDepositInfoResponsePayload = {
  message: string;
};

export type CommonResponsePayload = {
  message: string;
};
